// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/cancel_scheduled_plan_change.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/cancel_scheduled_plan_change.proto.
 */
export const file_vision_billing_v1_cancel_scheduled_plan_change: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vYmlsbGluZy92MS9jYW5jZWxfc2NoZWR1bGVkX3BsYW5fY2hhbmdlLnByb3RvEhhwcm90b3MudmlzaW9uLmJpbGxpbmcudjEifwogQ2FuY2VsU2NoZWR1bGVkUGxhbkNoYW5nZVJlcXVlc3QSUQoGcGFyYW1zGAEgASgLMkEucHJvdG9zLnZpc2lvbi5iaWxsaW5nLnYxLkNhbmNlbFNjaGVkdWxlZFBsYW5DaGFuZ2VSZXF1ZXN0LlBhcmFtcxoICgZQYXJhbXMilAEKIUNhbmNlbFNjaGVkdWxlZFBsYW5DaGFuZ2VSZXNwb25zZRJSCgZyZXN1bHQYASABKAsyQi5wcm90b3MudmlzaW9uLmJpbGxpbmcudjEuQ2FuY2VsU2NoZWR1bGVkUGxhbkNoYW5nZVJlc3BvbnNlLlJlc3VsdBobCgZSZXN1bHQSEQoJY2FuY2VsbGVkGAEgASgIYgZwcm90bzM");

/**
 * @generated from message protos.vision.billing.v1.CancelScheduledPlanChangeRequest
 */
export type CancelScheduledPlanChangeRequest = Message<"protos.vision.billing.v1.CancelScheduledPlanChangeRequest"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CancelScheduledPlanChangeRequest.Params params = 1;
   */
  params?: CancelScheduledPlanChangeRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CancelScheduledPlanChangeRequest.
 * Use `create(CancelScheduledPlanChangeRequestSchema)` to create a new message.
 */
export const CancelScheduledPlanChangeRequestSchema: GenMessage<CancelScheduledPlanChangeRequest> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_scheduled_plan_change, 0);

/**
 * @generated from message protos.vision.billing.v1.CancelScheduledPlanChangeRequest.Params
 */
export type CancelScheduledPlanChangeRequest_Params = Message<"protos.vision.billing.v1.CancelScheduledPlanChangeRequest.Params"> & {
};

/**
 * Describes the message protos.vision.billing.v1.CancelScheduledPlanChangeRequest.Params.
 * Use `create(CancelScheduledPlanChangeRequest_ParamsSchema)` to create a new message.
 */
export const CancelScheduledPlanChangeRequest_ParamsSchema: GenMessage<CancelScheduledPlanChangeRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_scheduled_plan_change, 0, 0);

/**
 * @generated from message protos.vision.billing.v1.CancelScheduledPlanChangeResponse
 */
export type CancelScheduledPlanChangeResponse = Message<"protos.vision.billing.v1.CancelScheduledPlanChangeResponse"> & {
  /**
   * @generated from field: protos.vision.billing.v1.CancelScheduledPlanChangeResponse.Result result = 1;
   */
  result?: CancelScheduledPlanChangeResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CancelScheduledPlanChangeResponse.
 * Use `create(CancelScheduledPlanChangeResponseSchema)` to create a new message.
 */
export const CancelScheduledPlanChangeResponseSchema: GenMessage<CancelScheduledPlanChangeResponse> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_scheduled_plan_change, 1);

/**
 * @generated from message protos.vision.billing.v1.CancelScheduledPlanChangeResponse.Result
 */
export type CancelScheduledPlanChangeResponse_Result = Message<"protos.vision.billing.v1.CancelScheduledPlanChangeResponse.Result"> & {
  /**
   * @generated from field: bool cancelled = 1;
   */
  cancelled: boolean;
};

/**
 * Describes the message protos.vision.billing.v1.CancelScheduledPlanChangeResponse.Result.
 * Use `create(CancelScheduledPlanChangeResponse_ResultSchema)` to create a new message.
 */
export const CancelScheduledPlanChangeResponse_ResultSchema: GenMessage<CancelScheduledPlanChangeResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_cancel_scheduled_plan_change, 1, 0);

